/* src/app/merchants/merchant-forms/merchant-forms.component.css */
.error {
  color: var(--danger);
}
.merchant-forms {
  padding: .75rem;
}
.merchant-form {
  padding: .75rem;
}
.merchant-form-header,
.merchant-form-link {
  color: #3b74b0;
}
/*# sourceMappingURL=merchant-forms.component.css.map */
